<template>
	<div id="app" v-resize:debounce="onResize" :class="[screenSize,'font-sans w-screen']">
		<router-view :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
import resize from 'vue-resize-directive';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'App',
	mounted: function() {
	},
	computed: {
		...mapGetters(['']),
	},
	methods: {
		...mapActions(['matchScreenSize']),
		onResize: function() {
			this.matchScreenSize().then(res => this.screenSize = res);
		},
	},
	directives: {
		resize,
	},
	data() {
		return {
			screenSize: '',
		};
	},
}
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
